import React, { useEffect, useState, useContext } from 'react'
import { Alert, Typography, Button, Collapse, Box, Card, Modal, Popover } from '@mui/material'
import { KeyboardArrowRight, DateRange as DateRangeIcon, Add as AddIcon, EventAvailable as EventAvailableIcon, HorizontalRule } from '@mui/icons-material'
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { PATHS } from '../../constants'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import { EmploymentsContext } from '../../contexts/EmploymentsContext'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'
import { Redirect } from 'react-router-dom'
import Notifications from './Notifications'
import ShiftSubmissions from './ShiftSubmissions'
import { isMobile } from '../../Utilities/isMobile'
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja', {
    months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'YYYY年M月D日',
        LLL: 'YYYY年M月D日 HH:mm',
        LLLL: 'YYYY年M月D日 dddd HH:mm'
    }
})

const Home = ({ history }) => {
    const [submitted, setSubmitted] = useState(true)
    const [notifications, setNotifications] = useState([])
    const [supporterNotifications, setSupporterNotifications] = useState([])
    const [supporterNotificationDetail, setSupporterNotificationDetail] = useState(null)
    const [calendarAnchorEl, setCalendarAnchorEl] = useState(null)
    const [selectedDate, setSelectedDate] = useState(moment())
    const { setUserEmployments, isManager, isAdmin, userInfo } = useContext(EmploymentsContext)
    const selectedEmploymentId = parseInt(localStorage.selected_emp)
    const [alerts, setAlerts] = useState([])
    const now = new Date()

    const firstHalf = now.getDate() < 16
    const currentShiftMonthDate = new Date()
    currentShiftMonthDate.setMonth(now.getMonth() + (firstHalf ? 1 : 2))
    const currentShiftMonth = currentShiftMonthDate.toISOString().slice(0, 7) // YYYY-MM
    // if it's earlier than the 16th, 'current' month is next month
    // later than the 16th -> month after next

    const handleNotificationClose = n => {
        AxiosWithAuth.put(`/notifications/${n.id}`, {
            is_read: true
        })
            .then(() => {
                const newNotifications = notifications.filter(not => not.id !== n.id)
                const updatedNotification = notifications.find(not => not.id === n.id)
                updatedNotification.is_read = true
                setNotifications([...newNotifications, updatedNotification])
            })
            .catch(err => console.log(err))
    }
    const getGreeting = () => {
        const currentHour = moment().hour();
        if (currentHour < 12) {
            return 'おはようございます🌿';
        } else if (currentHour < 18) {
            return 'こんにちは🌞';
        } else {
            return 'こんばんは🌙';
        }
    };

    const handleDateIconClick = (event) => {
        setCalendarAnchorEl(event.currentTarget)
    }

    const handleDateSelect = (date) => {
        setSelectedDate(date)
        setCalendarAnchorEl(null)
        history.push(PATHS.shiftManagement
            .replace(':employmentId', selectedEmploymentId)
            .replace(':calendarYearMonth', date.format('YYYY-MM-DD'))
            .replace(':tabValue', 'check'))
    }

    const handleCloseCalendar = () => {
        setCalendarAnchorEl(null)
    }

    useEffect(() => {
        AxiosWithAuth.get('/employments').then(res => {
            let submit = true
            setUserEmployments(res.data)
            res.data.forEach(e => {
                if (!(e.submitted.includes(currentShiftMonth) || e.confirmed.includes(currentShiftMonth))) {
                    // if any of the employments is missing a submitted shift for the current month
                    submit = false
                }
                if (e.notifications.length > 0) {
                    e.notifications.forEach(n => {
                        if (n.is_read === false) {
                            if (n.message.includes('ヘルプリクエストが入りました。')) {
                                setSupporterNotifications([...supporterNotifications, n])
                            } else {
                                setNotifications([...notifications, n])
                            }
                        }
                    })
                }
            })
            if (!submit) setSubmitted(false)
        })
        AxiosWithAuth.get('/alerts').then(res => {
            let combinedAlerts = []
            for (const [, value] of Object.entries(res.data)) {
                if (value.length > 0) {
                    combinedAlerts = [...combinedAlerts, ...value]
                }
            }
            setAlerts(combinedAlerts)
        })
    }, [firstHalf, currentShiftMonth])

    if (userInfo?.view_only) {
        return <Redirect to={PATHS.viewOnly.home} />
    }

    const homeComponent = (
        <PageWithTitleLayout title="ホーム">
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', my: 2, flexDirection: 'column' }}>
                    <Typography variant="h6">
                        {moment().format('YYYY年M月D日 ddd')}
                    </Typography>
                    <Typography variant="h7" sx={{ ml: 2 }}>
                        {getGreeting()}
                    </Typography>
                    <Button
                        variant='contained'
                        sx={{ m: 3, borderRadius: '20px'}}
                    >
                        <DateRangeIcon onClick={handleDateIconClick}/>
                        <HorizontalRule sx={{ transform: 'rotate(90deg)' }} />
                        <span 
                            onClick={() => history.push(PATHS.shiftManagement.replace(':employmentId', selectedEmploymentId).replace(':calendarYearMonth', moment().format('YYYY-MM-DD')).replace(':tabValue', 'check'))}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                            <Typography variant="h7">今日のシフトをチェック</Typography>
                            <KeyboardArrowRight />
                        </span>
                    </Button>
                    <Popover
                        open={Boolean(calendarAnchorEl)}
                        anchorEl={calendarAnchorEl}
                        onClose={handleCloseCalendar}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <Box sx={{ bgcolor: 'background.paper' }}>
                            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ja">
                                <StaticDatePicker
                                    value={selectedDate}
                                    onChange={handleDateSelect}
                                    slotProps={{
                                        actionBar: {
                                            actions: []
                                        },
                                        toolbar: {
                                            hidden: true
                                        }
                                    }}
                                    format="YYYY年MM月DD日"
                                />
                            </LocalizationProvider>
                        </Box>
                    </Popover>
                    {supporterNotifications.length > 0 && supporterNotifications.map((n, i) => (
                        <Collapse in={!n.is_read} key={i}>
                            <Alert severity="warning" sx={{ display: 'flex' }}>
                                {n.message}
                                <Button onClick={() => setSupporterNotificationDetail(n)}>確認する</Button>
                            </Alert>
                        </Collapse>
                    ))}
                    {supporterNotificationDetail && (
                        <Modal open={!!supporterNotificationDetail} onClose={() => setSupporterNotificationDetail(null)}>
                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', borderRadius: '10px', transform: 'translate(-50%, -50%)', width: isMobile() ? '80%' : '400px', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
                                <EventAvailableIcon sx={{ fontSize: '5rem', color: 'lightgray' }} />
                                <Typography variant="h6">
                                    {supporterNotificationDetail.message}
                                </Typography>
                                <Button variant="contained"
                                    color="primary" 
                                    onClick={() => 
                                        history.push(PATHS.shiftManagement.replace(':employmentId', supporterNotificationDetail.employment_id)
                                                                        .replace(':calendarYearMonth', supporterNotificationDetail?.message.split(' ')[0].replace('年', '-').replace('月', '-').replace('日', ''))
                                                                        .replace(':tabValue', 'check'))
                                    }
                                >
                                    シフトを確認する
                                </Button>
                                <Button onClick={() => setSupporterNotificationDetail(null)}>閉じる</Button>
                            </Box>
                        </Modal>
                    )}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-around', m: 2, flexDirection: isMobile() ? 'column' : 'row'}}>
                    <Card sx={{ width: isMobile() ? '90%' : '50%', minHeight: '30vh',display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2, mt: 2, mr: isMobile() ? '0' : '1rem' }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            📣 お知らせ
                        </Typography>
                        <Box sx={{overflow: 'auto', maxHeight: '50vh', width: '100%'}}>
                        {notifications.length > 0 &&
                            notifications.map((n, i) => (
                                <Collapse in={!n.is_read} key={i}>
                                    <Alert
                                        key={i}
                                        severity="info"
                                        onClose={() => handleNotificationClose(n)}
                                        sx={{ display: 'flex' }}
                                    >
                                        お知らせ
                                        <br />
                                        {n.message}
                                    </Alert>
                                </Collapse>
                            ))
                        }
                        {alerts.length > 0 &&
                            alerts.map(alert => (
                                <Alert severity={alert.severity} key={alert.message}>
                                    {alert.message}
                                </Alert>
                            ))
                        }
                            <Notifications />
                        </Box>
                    </Card>
                    <Card sx={{ width: isMobile() ? '90%' : '50%', minHeight: '30vh', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2, mt: 2 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            🗓️ シフト提出状況
                        </Typography>
                        <Alert severity="error" sx={{ display: !submitted && firstHalf ? 'flex' : 'none' }}>
                            お知らせ
                            <br />
                            {((currentShiftMonthDate.getMonth() + 11) % 12) + 1}月16日までに
                            {currentShiftMonthDate.getMonth() + 1}月のシフトを提出してください。
                        </Alert>
                        <Box sx={{overflow: 'auto', maxHeight: '50vh', width: '100%'}}>
                            <ShiftSubmissions currentShiftMonth={currentShiftMonth} />
                        </Box>
                    </Card>
                </Box>
            </Box>
            {(isManager || isAdmin) && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mr: '2rem', marginBottom: '4.5rem' }}>
                    <Button
                        onClick={e => {
                            e.preventDefault()
                            history.push(PATHS.signup)
                        }}
                        variant="contained"
                        endIcon={<AddIcon />}
                        sx={{
                            mt: 3,
                            height: '42px',
                            backgroundColor: '#E0E0E0',
                            color: 'black',
                            borderRadius: '20px'
                        }}
                    >
                        新規ユーザー登録
                    </Button>
                </Box>
            )}
        </PageWithTitleLayout>
    )

    return homeComponent
}

export default Home
